export const colors = {
  primary: "#1D3E6C",
  primaryLight: "#5bb8f2",
  primaryDark: "#122744",
  secondary: "#d1d92f",

  lightText: "#fff",
  helperGray: "#DDDDDD",
  helperGrayActive: "#B9B9B9",

  backgroundLight: "#F0F0F0",
  backgroundDark: "#F5F5F5",
};

export const MIN_INTERNET = 7;

export const localStorageConstants = {
  startTest: 'startTest'  
};
